import React from 'react';
import ReactStars from "react-rating-stars-component";


const Ratings = ({
    label,
    required,
    name,
    stars,
    value,
    onChange,
    className,
    isHalf = false,
    edit = true,
}) => {

    const ratingChanged = (newRating) => {
        onChange(newRating, name, "ratings");
    };

    return (
        <div className={className}>
            {
                label && <label htmlFor="name" className="mb-0">
                    <strong>{label}</strong>
                    {required === true && <span style={{ color: 'red' }} > * </span>}
                </label>
            }
            <ReactStars
                count={stars || 3}
                onChange={ratingChanged}
                size={24}
                value={value}
                isHalf={isHalf}
                activeColor="#ffd700"
                edit={edit}
            />
        </div>
    );
};

export default Ratings;